import React from 'react';
import { highlightSearchMatch } from '../utils/globalSearchFormatters';
export default function SearchHighlight({ text, query }) { return <>{highlightSearchMatch(text, query).map((part, index) => part.match ? <mark key={`${part.text}-${index}`}>{part.text}</mark> : <React.Fragment key={`${part.text}-${index}`}>{part.text}</React.Fragment>)}</>; }
